import React, { useState, useEffect } from 'react';
import { LOADING_IMG } from '../constants';

const LazyLoadImage = ({ imgSrc, alt, className, style, ...props }) => {
  const [src, setSrc] = useState(LOADING_IMG);

  // when imgSrc changes, reset to loading image
  useEffect(() => {
    setSrc(LOADING_IMG);
  }, [imgSrc]);

  const handleImageLoad = () => {
    setSrc(imgSrc);
  };

  return (
    <img
      src={src}
      alt={alt || 'Image'}
      className={className}
      style={style}
      data-src={imgSrc}
      onLoad={handleImageLoad}
      {...props}
    />
  );
};

export default LazyLoadImage;
